import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Message } from "primereact/message";
import "./Workflow.scss";
import { StreamInfo, useGetWorkflowsQuery } from "../../app/apiSlice";
import { TopBar } from "../../components/topBar/topBar";
import { DataTableWorkFlows } from "./DataTableWorkFlows";
import { useAppSelector, useInterval } from "../../hooks/hooks";
import { FilterWorkFlows } from "./FilterWorkFlows";
import { useSearchParams } from "react-router-dom";
import { convertQueryEnvToDropDownEnvValue, calculQueryEnv } from "../../components/environnement/utilsEnv";
import { filterFlowsByStatus, OTHER_STATUS, statusFlowList } from '../dashboard/DashboardOverview';

export interface DropdownItem {
  name: string;
  code: string;
}

// Generate list of Items for the status filter Dropdown
const statusFilterItems: DropdownItem[] = statusFlowList.concat(OTHER_STATUS).map((status) => ({
  name: status,
  code: status,
}));

export const Workflow = () => {
  const { t } = useTranslation();
  const [filteredWorkflows, setFilteredWorkflows] = useState<StreamInfo[]>([]);
  const [filter, setFilter] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<DropdownItem>();
  const [searchParams] = useSearchParams();
  const environnements = useAppSelector((state) => state.app.config.environnements)
  const [envsSelected, setSelectedEnvs] = useState<
  { name: string; code: string }[]
>(convertQueryEnvToDropDownEnvValue(searchParams.get("env"), environnements || []));

const queryEnv = useMemo(() => {
  return calculQueryEnv(envsSelected);
}, [envsSelected]);

  const { data: workflows, ...workflowsStatus } = useGetWorkflowsQuery({ env: queryEnv });

  useInterval(() => {
    // TODO use websocket ;)
    workflowsStatus.refetch();
  }, 5000);

  useEffect(() => {
    const queryState = searchParams.get("state");
    if (queryState) {
      const statusFilter = statusFilterItems.find((param) => param.code === queryState);
      if (statusFilter) {
        setSelectedStatus(statusFilter);
      }
    }
  }, []);

  // Filter workflows
  useEffect(() => {
    if (workflows) {
      setFilteredWorkflows(
        workflows.filter(
          (t) =>
            // Filter by name
            (filter === "" ||
              t.label.toLowerCase().includes(filter.toLowerCase()) ||
              t.run_id.toLowerCase().includes(filter.toLowerCase())) &&
            // Filter by status
            (selectedStatus === undefined || filterFlowsByStatus(selectedStatus.name, t.status))
        )
      );
    }
  }, [workflows, filter, selectedStatus]);

  return (
    <div className="w-full">
      <TopBar left={<h2>Flux</h2>} right={undefined}></TopBar>
      {!workflowsStatus.isError && (
        <div className="mr-4 ml-4">
          <div className="mt-4 mb-4">
            <FilterWorkFlows
              envsSelected={envsSelected}
              setSelectedEnvs={(value) => setSelectedEnvs(value)}
              filterNameOrId={filter}
              setFilterNameOrID={(value) => setFilter(value)}
              setSelectedStatus={(value) => setSelectedStatus(value)}
              selectedStatus={selectedStatus}
              statusFilterItems={statusFilterItems}
            />
          </div>
          <div>
            <DataTableWorkFlows
              refetchStream={() => workflowsStatus.refetch()}
              isLoading={workflowsStatus.isLoading}
              workflows={filteredWorkflows}
            />
          </div>
        </div>
      )}
      <div className="m-4">
        {workflowsStatus.isError && (
          <Message
            severity="error"
            className="w-full"
            text={t("message.flow.not-found")}
          />
        )}
      </div>
    </div>
  );
};
